// @flow
import React, { PureComponent } from 'react';
import type { Node } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

// Components
import Icon from 'Common/Icon';

// Helpers
import { getDisplay, createValue } from 'Common/formValues';
import { gtmEventPush } from 'utils/gtm/events';

// Helpers
import classNames from 'classnames';

/**
 * <Select /> component.
 */
class Select extends PureComponent<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {object} styles - Input styles.
   * @prop {object} bootstrap - bootstrap styles
   * @prop {string} name - input name.
   * @prop {string} label - label
   * @prop {array} options - list of options
   * @prop {string} selectedValue - value
   * @prop {bool} isDisabled - value
   * @prop {bool} borderRight - border
   * @prop {func} resetField - resetField
   * @prop {func} onChange - onChange
   * @prop {func} isMobile - isMobile
   */
  static propTypes = {
    styles: PropTypes.object.isRequired,
    bootstrap: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.array,
    selectedValue: PropTypes.string,
    isDisabled: PropTypes.bool,
    borderRight: PropTypes.bool,
    resetField: PropTypes.func,
    onChange: PropTypes.func,
    isMobile: PropTypes.bool
  };

  onChange: () => void = () => {
    const { resetField, onChange, label, name } = this.props;
    gtmEventPush({
      method: 'filterForm',
      args: {
        itemLabel: label
      }
    });
    if (name === 'make' && resetField) {
      resetField('model');
      resetField('category');
      resetField('trim');
    }
    onChange && onChange();
  };

  /**
   * Renders <Select /> component.
   *
   * @return {JSX} - renders a Select.
   */
  render(): Node {
    const {
      styles,
      bootstrap,
      name,
      label,
      options,
      selectedValue,
      isDisabled,
      borderRight,
      isMobile
    } = this.props;

    return (
      <div className={borderRight ? styles.borderRight : null}>
        <label className={bootstrap.srOnly} htmlFor={name}>
          {label}
        </label>
        <Field
          name={name}
          className={classNames(bootstrap.formControl, styles.select)}
          onChange={this.onChange}
          disabled={isDisabled}
          component="select"
          value={createValue(selectedValue)}
        >
          <option value="">{label}</option>
          {options &&
            options.map((item, index) => (
              <option value={createValue(item)} key={index}>
                {getDisplay(JSON.stringify(item))}{' '}
                {item.doc_count
                  ? `(${item.doc_count.toLocaleString('en')})`
                  : ''}
              </option>
            ))}
        </Field>
        <Icon
          iconName={isMobile ? 'angle-down' : 'chevron-down-small'}
          size={'default'}
          className={styles.icon}
        />
      </div>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/Common/Select/index.js